import { all } from "redux-saga/effects";
import AuthSagas from "./Auth/sagas";
import ProductsSagas from "./Products/sagas";
import LookupsSagas from "./Lookups/sagas";
import NotificationsSagas from "./Notifications/sagas";
import CategoriesSagas from "./Categories/sagas";
import SubCategoriesSagas from "./SubCategories/sagas";
import UsersSaga from "./Users/sagas";
import BusinessVerificationSagas from "./BusinessVerification/sagas";
import VouchersSagas from "./Vouchers/sagas";
import TransactionsSaga from "./Transactions/sagas";
import EmployeesSagas from "./Employees/sagas";
import RolesSagas from "./Roles/sagas";

export default function* rootSaga() {
  yield all([
    AuthSagas(),
    ProductsSagas(),
    LookupsSagas(),
    NotificationsSagas(),
    CategoriesSagas(),
    SubCategoriesSagas(),
    UsersSaga(),
    BusinessVerificationSagas(),
    VouchersSagas(),
    TransactionsSaga(),
    EmployeesSagas(),
    RolesSagas()
  ]);
}
